import React from 'react';
import styled from 'styled-components';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Row, Col, FormGroup, InputGroup, Button } from "reactstrap";
import { SmallFormFeedback, Spacer, PinkButtonContainer, EditIcon } from "../../../../utils/budget-tool-specific";
import { RebelColors } from "../../../../styles/rebel-experiences";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export function RebelSortableItem(props) {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
        isDragging,
    } = useSortable({ id: props.id });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.5 : 1,
        width: '100%',
    };

    return (
        <div ref={setNodeRef} style={style}>
            <Row key={props.id}>
                <Col xs="auto" style={{display: 'flex', alignItems: 'center', paddingRight: 0}}>
                    <RebelFAIcon
                        icon={["fas", "grip-vertical"]}
                        {...attributes}
                        {...listeners}
                        style={{ cursor: isDragging ? 'grabbing' : 'grab' }}
                    />
                </Col>
                <Col lg="5">
                    <FormGroup>
                        <RebelLabel>Cost Title</RebelLabel>
                        <InputGroup>
                            <RebelInput
                                placeholder=""
                                type="text"
                                value={props.miscCost[1].title}
                                onChange={e => props.handleMiscellaneousChange(e.target.value, props.miscCost[1].id, "title")}
                            />
                            <RebelFormFeedback>Required</RebelFormFeedback>
                        </InputGroup>
                    </FormGroup>
                </Col>
                <Col lg="5">
                    <FormGroup>
                        <RebelLabel>Cost</RebelLabel>
                        <InputGroup>
                            <RebelInputGroupText>
                                {props.currency}
                            </RebelInputGroupText>
                            <RebelCostInput
                                placeholder=""
                                type="number"
                                value={props.miscCost[1].cost}
                                onChange={e => props.handleMiscellaneousChange(parseInt(e.target.value), props.miscCost[1].id, "cost")}
                            />
                            <RebelFormFeedback>Required</RebelFormFeedback>
                            <RebelInputGroupText style={{padding: "0px"}}>
                                <RebelCheckboxButton onClick={x => props.handleMiscellaneousChange(props.miscCost[1].pp, props.miscCost[1].id, "pp")}>
                                    {props.miscCost[1].pp}
                                </RebelCheckboxButton>
                            </RebelInputGroupText>
                        </InputGroup>
                    </FormGroup>
                </Col>
                <Col lg="1">
                    <Spacer height="30px"></Spacer>
                    <RebelDeleteButtonContainer onClick={(x) => props.deleteMiscCost(props.miscCost[1].id)}>
                        <RebelEditIcon icon={['fas', 'trash']} style={{height: "25px"}}/>
                    </RebelDeleteButtonContainer>
                </Col>
            </Row>
        </div>
    )
}

const RebelFAIcon = styled(FontAwesomeIcon)`
    color: ${RebelColors.gold};
    display: flex;
    height: 100%;
`;

const RebelLabel = styled.label`
    color: ${RebelColors.gold};
    font-weight: 500;
    margin-bottom: 8px;
    font-size: 0.95rem;
    display: block;
`;

const RebelInput = styled.input`
    font-size: 16px;
    border: 1px solid ${RebelColors.border};
    border-radius: 6px;
    background-color: #3b3f45;
    color: ${RebelColors.text};
    padding: 10px 16px;
    min-height: 46px;
    transition: all 0.3s ease;
    width: 100%;

    &:focus {
        background-color: #424752;
        border-color: ${RebelColors.gold};
        box-shadow: 0 0 0 3px rgba(255, 215, 0, 0.1);
        color: ${RebelColors.text};
        outline: none;
    }

    &::placeholder {
        color: ${RebelColors.primaryMuted};
    }

    &:hover {
        border-color: ${RebelColors.borderLight};
        background-color: #424752;
    }

    &:disabled {
        background-color: ${RebelColors.surface};
        color: ${RebelColors.primaryMuted};
        cursor: not-allowed;
    }
`;

const RebelCostInput = styled(RebelInput)`
    max-width: 120px;
`;

const RebelInputGroupText = styled.span`
    background-color: #2a2e34;
    border: 1px solid ${RebelColors.border};
    color: ${RebelColors.text};
    border-radius: 6px;
    padding: 10px 16px;
    min-height: 46px;
    display: flex;
    align-items: center;
`;

const RebelFormFeedback = styled(SmallFormFeedback)`
    color: ${RebelColors.danger};
`;

const RebelCheckboxButton = styled(Button)`
    height: 100%;
    margin: 0px;
    border: none;
    border-radius: 0px;
    background-color: ${RebelColors.gold};
    color: #000000;
    min-height: 46px;
    padding: 10px 16px;
    font-weight: 500;
    transition: all 0.3s ease;

    &:hover {
        background-color: #e6c200;
        color: #000000;
    }

    &:focus {
        background-color: ${RebelColors.gold};
        color: #000000;
        box-shadow: 0 0 0 3px rgba(255, 215, 0, 0.2);
    }

    &:active {
        background-color: #cca300;
        color: #000000;
    }
`;

const RebelDeleteButtonContainer = styled(PinkButtonContainer)`
    background-color: transparent;
    border: 1px solid ${RebelColors.border};
    transition: all 0.3s ease;

    &:hover {
        background-color: ${RebelColors.danger};
        border-color: ${RebelColors.danger};
    }
`;

const RebelEditIcon = styled(EditIcon)`
    color: ${RebelColors.primary};

    ${RebelDeleteButtonContainer}:hover & {
        color: #ffffff;
    }
`;
